import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["name", "scale", "breakpoints", "size", "inverted", "shady", "square", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { createStyleFunction } from 'utils/ui';
import { pxToEm } from 'utils/ui/units';
import { alpha } from 'utils/ui/colors';
import Icon from 'components/Icon';
import { marginPropsDef } from 'styles/styleProps';
import { responsiveScaleProp, scalePresets } from 'components/CircleImage';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var wrapperStyleProps = createStyleFunction(marginPropsDef);

/* Components */

export var Wrapper = styled.span.withConfig({
  displayName: "IconDisc__Wrapper",
  componentId: "sc-1w4gzm8-0"
})(["position:relative;display:inline-block;vertical-align:middle;", ""], wrapperStyleProps);
export var Disc = styled.span.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['scale', 'breakpoints', 'shady', 'inverted', 'square'].includes(prop);
  }
}).withConfig({
  displayName: "IconDisc__Disc",
  componentId: "sc-1w4gzm8-1"
})(["display:flex;justify-content:center;align-items:center;width:", ";height:", ";font-size:1rem;", " color:", ";background-color:", ";", " ", " ", " box-shadow:0 0 3px ", ";transition:background-color 250ms ease-in;"], pxToEm(34), pxToEm(34), responsiveScaleProp, function (p) {
  return p.theme.text;
}, function (p) {
  return p.theme.background;
}, function (p) {
  return p.shady && css(["background-color:", ";"], function (p) {
    return alpha(p.theme.shade, p.theme.shadeStrength);
  });
}, function (p) {
  return p.inverted && css(["color:", ";background-color:", ";"], function (p) {
    return p.theme.background;
  }, function (p) {
    return p.theme.text;
  });
}, function (p) {
  return !p.square && css(["border-radius:100%;"]);
}, function (p) {
  return alpha(p.theme.shade, 0.2);
});
var IconDisc = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var name = _ref.name,
    scale = _ref.scale,
    breakpoints = _ref.breakpoints,
    size = _ref.size,
    inverted = _ref.inverted,
    shady = _ref.shady,
    square = _ref.square,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var sizeOverrideProps = size && scalePresets[size];
  return /*#__PURE__*/_jsx(Wrapper, _objectSpread(_objectSpread({
    ref: ref
  }, otherProps), {}, {
    children: /*#__PURE__*/_jsxs(Disc, _objectSpread(_objectSpread({
      scale: scale,
      breakpoints: breakpoints
    }, sizeOverrideProps), {}, {
      inverted: inverted,
      shady: shady,
      square: square,
      children: [/*#__PURE__*/_jsx(Icon, {
        name: name,
        "data-iconname": name
      }), children]
    }))
  }));
});
IconDisc.displayName = 'IconDisc';
export default IconDisc;